const dynamicVariablePrefixes = ["$NOW", "$CURRENT_USER", "$CURRENT_ROLE"];

export function isDynamicVariable(value: any) {
  return (
    typeof value === "string" &&
    dynamicVariablePrefixes.some((prefix) => value.startsWith(prefix))
  );
}
